// extracted by mini-css-extract-plugin
module.exports = {"box":"FieldIntegrationMappingCell_box__1GYvC","center":"FieldIntegrationMappingCell_center__2rrZJ","text":"FieldIntegrationMappingCell_text__1YdtU"};